'use client';

import { ListingModel } from '@bw/apis/contentful';
import { Image } from '@bw/elements';
import { LogoVector, Quote } from '@bw/elements/icons';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/mousewheel';
import 'swiper/css/scrollbar';
import { A11y, Autoplay, Mousewheel, Scrollbar } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './PersonCardSliderSection.module.scss';

type PersonCardSliderSectionClientProps = {
	fields: ListingModel['fields'];
};

export function PersonCardSliderSectionClient({
	fields,
}: PersonCardSliderSectionClientProps) {
	const personData = fields.personCard;

	const options_method = {
		renderNode: {
			[BLOCKS.PARAGRAPH]: (node: unknown, children: React.ReactNode) => {
				return <>{children}</>;
			},
		},
	};

	return (
		<div className={styles['PersonCardSliderSection']}>
			<div className="container">
				<div className="PersonCardSliderSection__header">
					<article>
						<h2 data-aos="fade-up">{fields?.heading}</h2>
					</article>
					<figure data-aos="fade-up">
						<Quote width={107} height={80} />
					</figure>
				</div>
			</div>
			<div className="PersonCardSliderSection__wrapper">
				<Swiper
					modules={[Autoplay, Scrollbar, A11y, Mousewheel]}
					autoplay={{ delay: 20, disableOnInteraction: true }}
					loop={true}
					speed={10000}
					draggable={true}
					breakpoints={{
						375: {
							slidesPerView: 1.7,
							spaceBetween: 10,
						},
						767: {
							slidesPerView: 2.8,
							spaceBetween: 30,
						},
						1024: {
							slidesPerView: 3.7,
							spaceBetween: 40,
						},
						1440: {
							slidesPerView: 3.7,
							spaceBetween: 40,
						},
					}}
				>
					{(personData ?? []).map((person, index) => {
						const f = person?.fields as {
							personName?: string;
							designation?: string;
							details?: import('@contentful/rich-text-types').Document;
							image?: { fields?: { image?: { fields?: { file?: { url?: string; details?: { image?: { height?: number; width?: number } } }; title?: string } } } };
						};
						const imageUrl = f?.image?.fields?.image?.fields?.file?.url;
						const imageTitle = f?.image?.fields?.image?.fields?.title;
						const imageHeight = f?.image?.fields?.image?.fields?.file?.details?.image?.height;
						const imageWidth = f?.image?.fields?.image?.fields?.file?.details?.image?.width;
						return (
							<SwiperSlide key={index}>
								<div className="PersonCardSliderSection__item">
									{imageUrl && (
										<figure className="slider__photo">
											<Image
												src={imageUrl}
												alt={imageTitle ?? ''}
												height={imageHeight ?? 500}
												width={imageWidth ?? 500}
												sizes="(max-width: 766px) 33vw, 15vw"
												focus='face'
											/>
										</figure>
									)}
									<p className="testimonial-name" data-aos="fade-up">
										{' '}
										{f?.personName}
									</p>
									<p className="testimonial-designation" data-aos="fade-up">
										{f?.designation}
									</p>
									<p data-aos="fade-up">
										{f?.details && documentToReactComponents(f.details, options_method)}
									</p>
									{imageUrl ? (
										<figure className="logo__layer --tall">
											<LogoVector width={141} height={286} />
										</figure>
									) : (
										<figure className="logo__layer">
											<LogoVector width={81} height={226} />
										</figure>
									)}
								</div>
							</SwiperSlide>
						);
					})}
				</Swiper>
			</div>
		</div>
	);
}
